import React from "react";
import { Adder } from "../../button/Adder";
import styles from "./ItemAdder.scss";
export const ItemAdder = (props) => {
    return (
        <div className={styles.adder}>
            <Adder {...props} />
        </div>
    );
};
